import React from "react";

type Option<T> = {
  value: T;
  label?: string;
};

type Props<T> = {
  name: string;

  options: Option<T>[];

  value: T;
  onSelect: (v: string) => void;

  disabled?: boolean;
  subHeader?: string;
};

const SquareRadio = <T extends number | string>({
  name,
  options,
  value,
  onSelect,
  disabled,
  subHeader,
}: Props<T>) => {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onSelect(e.target.value);
  }

  return (
    <div className="self-stretch flex-grow flex flex-row">
      {options.map((option, idx) => {
        const isSelected = option.value === value;
        return (
          <div className="flex-1 flex" key={`buttons-${name}-${idx}`}>
            <input
              tabIndex={0}
              disabled={disabled}
              name={name}
              type="radio"
              id={name + idx}
              value={option.value}
              checked={isSelected}
              onChange={handleChange}
              className="opacity-0 h-0 w-0 p-0 m-0"
            />
            <label
              htmlFor={name + idx}
              id={name + idx + "-label"}
              className={`
                        text-base leading-6 cursor-pointer p-1 border border-gray-700
                        w-auto text-center flex flex-col items-center justify-center flex-1
                        ${disabled ? "opacity-50" : ""}
                        ${isSelected ? "bg-gray-drk outline outline-2 outline-gray-700 z-10" : "bg-gray-light"}
                    `}
            >
              <div>{option.label ?? option.value}</div>
              <div className="text-sm leading-5">{subHeader}</div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default SquareRadio;
